import Store from 'store/store';

import { 
	LANDING, INTRO, HABITAT1, HABITAT2, HABITAT3, PLEDGE
} from 'helpers/constants';

export const scrollStages = [LANDING, INTRO, HABITAT1, HABITAT2, HABITAT3, PLEDGE];

export const hasPassedStage = (stage) => {
	const targetStageIndex = scrollStages.indexOf(stage);
	const currentStageIndex = scrollStages.indexOf(Store.get().main.scrollStage);
	return currentStageIndex >= targetStageIndex;
};